import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ExportTemplatesName,
  ExportTemplatesRoute,
} from '@/modules/to/exporttemplates/exporttemplates.constants';
import { ExportTemplatesRouteConfig } from '@/modules/to/exporttemplates/ExportTemplatesRouteConfig';

export const router = ExportTemplatesRouteConfig.factory(
  [
    {
      path: ExportTemplatesRoute.EXPORT_TEMPLATES,
      name: ExportTemplatesName.EXPORT_TEMPLATES,
      component: () =>
        import(/* webpackChunkName: "export-templates-page" */ `./pages/ExportTemplates.vue`),
    },
  ],
  Module.ADFLO_PROPOSAL
);
